import { render } from "./form-layout.vue?vue&type=template&id=0fb1c536"
import script from "./form-layout.vue?vue&type=script&lang=js"
export * from "./form-layout.vue?vue&type=script&lang=js"

import "./form-layout.vue?vue&type=style&index=0&id=0fb1c536&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__